import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { BsFillReplyAllFill, BsDash } from "react-icons/bs";
import { FiChevronUp } from "react-icons/fi";
import { riad, spokenEnglish } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";
import CoursesIntro from "../../components/pageProps/CoursesIntro";
import Bonus from "../../components/pageProps/Bonus";

const SpokenEnglish = () => {
  // ================ Course Module start here ==================
  const [showCourseMaterials, setShowCourseMaterials] = useState(true);
  const [showCourseFacilities, setShowCourseFacilities] = useState(false);
  // ================ Course Module end here ====================
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>Spoken English - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Spoken English" />
      <div className="max-w-screen-xl mx-auto pb-4 flex flex-row md:flex-col lgl:flex-row items-start xl:gap-10 justify-between px-10">
        <div className="w-full flex flex-col gap-2">
          {/* =====================================================
                        Course Intro start here
           ===================================================== */}
          <CoursesIntro
            intro="Introduction"
            des=" Learn to speak English naturally. Become a fluent English speaker &
          secure your bright career. It's a complete course who are seeking to
          be fluent English speakers."
            instructorName="Riad Ahamed"
            instructorTitle="Sr. Instructor, Spoken English"
            instructorImg={riad}
            classTitle="Regular Class"
            classNo="24"
            langClubTitle="LANGUAGE CLUB"
            langClubNo="12"
            debate="Debate"
            supportTitle="SUPPORT"
            support="24/7"
            bg={spokenEnglish}
          />
          {/* =====================================================
                        Course Intro end here
           ===================================================== */}

          {/* =====================================================
                        Course overview start here
           ===================================================== */}
          <div>
            <h3 className="font-titleFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Why Spoken English course is for you?
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <p className="text-[16px] font-bodyFont tracking-wide text-gray-600">
                  As we already know that English is an English international
                  language, so the demand for Speaking English is also
                  worldwide. From our daily life to the professional sector, the
                  importance of English is boundless. Fluent English speakers
                  can easily shine in their academic education, career, and
                  competitive exam. Many of us are skilled in English but we
                  can't speak up in public due to confidence, enough practice &
                  accurate guidance. So, EduCare English Learning Academy is
                  here to improve your speaking naturally.
                </p>
                <ul className="flex flex-col mt-2 gap-1 font-bodyFont text-gray-700">
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    To be confident & speak English fluently.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    Present yourself as smart to your colleagues, friends &
                    clients.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    To garb the working opportunity in the best MNC.
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    For higher education purposes abroad.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* =====================================================
                        Course overview end here
           ===================================================== */}
          {/* =====================================================
                        Course MODULE start here
           ===================================================== */}

          <h3 className="font-titleFont text-xl md:text-2xl font-semibold">
            Course Modules
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4">
            {/* =================== Course materials Start here ============== */}
            <div>
              <h3
                onClick={() => setShowCourseMaterials(!showCourseMaterials)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Course materials / Learnings :
                {showCourseMaterials ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showCourseMaterials && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        English for everyday situations
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Basic Grammar (Sentences, Parts of Speech, tenses,
                        active and passive voice, direct and indirect
                        Narration).
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Communication with people in the classroom and in real
                        situations in class excursion projects.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Skills to Speak accurately and clearly.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Improving pronunciation and fluency.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Vocabulary Extending Program (VEP).
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Skills to the pathway of IELTS, abroad studies, and
                        job-getting skills.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Body Language Skills.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        English Language Tags.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        English Stressed words and facial expressions.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Overcoming fear and building confidence tactics.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Gathering, paraphrasing, and summarizing information for
                        presentation.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Editing and redrafting the information.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Oral Presentation and rehearsal of interviews.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        CV writing, preparation, and maintaining Biodata.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Course Facilities Start here ============== */}
            <div>
              <h3
                onClick={() => setShowCourseFacilities(!showCourseFacilities)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Course Facilities :
                {showCourseFacilities ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showCourseFacilities && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        03 classes in a week (a language club included).
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Our maximum class time is at night. So, if you are a job
                        holder/ student can easily join the class.
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Recorded video of a live class, in case you, miss the
                        live class. We always prefer to be present in the live
                        session.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Opportunity to study in a group.
                      </li>
                      <li className="courseModuleListliTwo">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Short support (if you are a student & recently you have
                        a presentation in your school then we will arrange a
                        session with our teachers so that you can get the
                        necessary tips about a successful presentation. Also, if
                        you are a job seeker then the teacher will help you to
                        present yourself as more confident in your recent
                        interviews.)
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Class notes & other materials.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        One-to-one interview sessions.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Debating club.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
          </div>
          <div>
            <Bonus
              bonus="We will arrange free interview secession for you."
              awards="Based on your performance, you will be awarded. Also, we will provide you with the certificate after completing the course."
            />
          </div>
          {/* =====================================================
                        Course MODULE end here
           ===================================================== */}
        </div>
      </div>
    </div>
  );
};

export default SpokenEnglish;
